import { useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../hooks'
import { getFilesUploadedList, useFileDropzone } from '../../../File'
import { getTask, updateTask } from '../../Task.api'

import { getNextFilesIds } from './useTaskTableItemAttachFile.utils'

export function useTaskTableItemAttachFile(props) {
  const { t } = useTranslation()

  const activeItemIdRef = useRef(null)

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const handleFinishUpload = useCallback(
    (acceptedFiles, errorFiles) => {
      if (acceptedFiles.length > 0) {
        getTask(activeItemIdRef.current)
          .then(({ data }) => {
            return updateTask(
              getNextFilesIds(data.files, acceptedFiles),
              activeItemIdRef.current
            )
          })
          .then(() => {
            props.setPerformingMassAction(false)

            handleAddSuccessNotification({
              title: t('Notification.CommonTitleAttachedFilesKey', {
                count: acceptedFiles.length,
                totalCount: acceptedFiles.length + errorFiles.length,
              }),
            })

            activeItemIdRef.current = null

            props.onReload()
          })
          .catch(() => {
            props.setPerformingMassAction(false)

            activeItemIdRef.current = null

            handleAddErrorNotification('Error.CommonApiRequestFailKey')
          })
      } else if (errorFiles.length > 0) {
        props.setPerformingMassAction(false)

        handleAddErrorNotification(
          'Notification.CommonTitleAttachedFilesErrorKey'
        )
      } else {
        props.setPerformingMassAction(false)
      }
    },
    [props.onReload]
  )

  const handleStartUpload = useCallback(() => {
    props.setPerformingMassAction(true)
  }, [])

  const {
    getInputProps: getFileAttachInputProps,
    getRootProps: getFileAttachRootProps,
    open: handleOpenFileAttach,
  } = useFileDropzone({
    getFiles: getFilesUploadedList,
    onCloseModal: props.onCloseModal,
    onFinishUpload: handleFinishUpload,
    onSetModal: props.onSetModal,
    onStartUpload: handleStartUpload,
  })

  return {
    activeItemIdRef,
    getFileAttachInputProps,
    getFileAttachRootProps,
    handleOpenFileAttach,
  }
}
